import { createFileRoute } from '@tanstack/react-router'
import { BookOpen } from 'lucide-react'

import { PageEmpty } from '../components/PageEmpty.js'

export const Route = createFileRoute('/spaces')({
  component: () => <PageEmpty page="spaces" icon={BookOpen} />,
})
